"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgPantographTopDown = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M22 3H2v2h8.382l2.49 4.98-2.466 4.52h-1.87l-.704-1.055a1 1 0 0 0-1.664 1.11l.852 1.277a1.5 1.5 0 0 0 1.248.668h7.464a1.5 1.5 0 0 0 1.249-.668l.851-1.277a1 1 0 0 0-1.664-1.11l-.703 1.055h-2.78l1.943-3.562a2 2 0 0 0 .033-1.853L12.618 5H22V3ZM2 21h20v-2H2v2Z" })), 'SvgPantographTopDown');
exports.default = SvgPantographTopDown;
